const pixelId = (process.env.REACT_APP_META_PIXEL_ID || "").trim();
let initialized = false;

export function initMetaPixel() {
  if (!pixelId || initialized || typeof window === "undefined") return;

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  window.fbq("init", pixelId);
  initialized = true;
}

export function track(eventName, params = {}, eventId) {
  if (!pixelId || typeof window === "undefined") return;
  initMetaPixel();
  if (typeof window.fbq !== "function") return;
  if (eventId) {
    window.fbq("track", eventName, params, { eventID: eventId });
  } else {
    window.fbq("track", eventName, params);
  }
}

export const meta = {
  pageView: () => track("PageView"),
  viewContent: (p) => track("ViewContent", p),
  addToCart: (p) => track("AddToCart", p),
  initiateCheckout: (p) => track("InitiateCheckout", p),
  purchase: (p, eventId) => track("Purchase", p, eventId),
  lead: (p = {}, eventId) => track("Lead", p, eventId),
};

export const variantId = (slug, sizeLabel) =>
  `${slug}-${String(sizeLabel || "").toLowerCase().replace(/[^a-z0-9]+/g, "")}`;

export const productParams = (item, qty = 1) => ({
  content_ids: [variantId(item.slug, item.size)],
  content_type: "product",
  contents: [{ id: variantId(item.slug, item.size), quantity: qty, item_price: Number(item.price) }],
  content_name: `${item.name}${item.size ? ` (${item.size})` : ""}`,
  value: Number(item.price) * qty,
  currency: "INR",
});

export const cartParams = (items, total) => ({
  content_ids: items.map((i) => variantId(i.slug, i.size)),
  content_type: "product",
  contents: items.map((i) => ({ id: variantId(i.slug, i.size), quantity: i.qty, item_price: Number(i.price) })),
  num_items: items.reduce((n, i) => n + i.qty, 0),
  value: Number(total),
  currency: "INR",
});
